import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-one-line-avatar-card',
  templateUrl: './one-line-avatar-card.component.html',
  styleUrls: ['./one-line-avatar-card.component.scss'],
})
export class OneLineAvatarCardComponent {
  @Input() avatarPhoto = 'assets/svg/avatar-white.svg';
  @Input() title: string;
  @Input() extraInformationOne: string;
  @Input() extraInformationTwo: string;
  @Input() bold = false;
}
